import awards from "../../shared/us.awards";
import branded_quotes from "../../shared/us.branded_quotes";
import verticals from "./us-consumer.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "us-consumer-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/404",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "us-consumer-home":
            return {
                page,
                helmet: {
                    meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
                    meta_description:
                        "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
                    canonical_url: "https://www.rosettastone.com/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
